export default __webpack_public_path__ + "static/media/success.e27b16d9.png";